const TOKEN = {
  heading: "#1f2937", // design-ok: gray-800, en CSS brut faute de classe possible
  link: "#2563eb", // design-ok: blue-600, en CSS brut faute de classe possible
  linkHover: "#1d4ed8", // design-ok: blue-700, en CSS brut faute de classe possible
  codeBg: "#f3f4f6", // design-ok: gray-100, en CSS brut faute de classe possible
  codeText: "#dc2626", // design-ok: red-600, en CSS brut faute de classe possible
  quoteRule: "#d1d5db", // design-ok: gray-300, en CSS brut faute de classe possible
  quoteText: "#6b7280", // design-ok: gray-500, en CSS brut faute de classe possible
  quoteBg: "#f9fafb", // design-ok: gray-50, en CSS brut faute de classe possible
};

export const getHtmlContentStyles = (className: string = "html-content") => `
  .${className} {
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .${className} font[size="3"] {
    font-size: inherit;
  }
  .${className} h1 {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} h2 {
    font-size: 1.3em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} h3 {
    font-size: 1.1em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} h4 {
    font-size: 1em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} h5 {
    font-size: 0.9em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} h6 {
    font-size: 0.8em;
    font-weight: bold;
    margin: 0.5em 0;
    line-height: 1.2;
    color: ${TOKEN.heading};
  }
  .${className} p {
    margin: 0.25em 0;
    line-height: 1.4;
  }
  .${className} strong, .${className} b {
    font-weight: bold;
  }
  .${className} em, .${className} i {
    font-style: italic;
  }
  .${className} u {
    text-decoration: underline;
  }
  .${className} s, .${className} strike {
    text-decoration: line-through;
  }
  .${className} sub {
    vertical-align: sub;
    font-size: smaller;
  }
  .${className} sup {
    vertical-align: super;
    font-size: smaller;
  }
  .${className} ul {
    list-style-type: disc;
    margin-left: 20px;
    padding-left: 20px;
    margin: 0.5em 0;
  }
  .${className} ol {
    list-style-type: decimal;
    margin-left: 20px;
    padding-left: 20px;
    margin: 0.5em 0;
  }
  .${className} li {
    margin-bottom: 4px;
    line-height: 1.4;
  }
  .${className} a {
    color: ${TOKEN.link};
    text-decoration: underline;
    cursor: pointer;
  }
  .${className} a:hover {
    color: ${TOKEN.linkHover};
    text-decoration: underline;
  }
  .${className} code {
    background-color: ${TOKEN.codeBg};
    color: ${TOKEN.codeText};
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.9em;
  }
  .${className} blockquote {
    border-left: 4px solid ${TOKEN.quoteRule};
    margin: 16px 0;
    font-style: italic;
    color: ${TOKEN.quoteText};
    background-color: ${TOKEN.quoteBg};
    padding: 12px 16px;
    border-radius: 4px;
  }
  .${className} blockquote::before {
    content: none;
  }
  .${className} blockquote p {
    margin: 0;
  }
`;

export const HTML_CONTENT_CLASS = "html-content";
